import { Text, View } from "@react-pdf/renderer";
import styles from '../styles/styles';
import Element from "./element";

interface BiomassProps {
  labels: {
    header: string;
    category: string;
    type: string;
    riscAssessment: string;
    certificationNumbers: string;
  };
  data: {
    category: string | null | undefined;
    type: string | null | undefined;
    riscAssessment: string | undefined;
    fscCertificationNumber: string | null | undefined;
    pefcCertificationNumber: string | null | undefined;
    legacyCertificationNumber: string | null | undefined;
  };
}

const Biomass = ({ labels, data }: BiomassProps) => {
  const certificationNumbers = [
    data.fscCertificationNumber,
    data.pefcCertificationNumber,
    data.legacyCertificationNumber,
  ].filter((value): value is string => typeof value === "string" && value.length > 0);
  const certificationNumbersText =
    certificationNumbers.length > 0 ? certificationNumbers.join("\n") : undefined;

  return (
    <>
      <View style={styles.row}>
        <Text style={styles.subHeader}>{labels.header}</Text>
      </View>

      {(data.category !== undefined ||
        data.type !== undefined ||
        data.riscAssessment !== undefined ||
        certificationNumbersText !== undefined) && (
        <>
          <View style={styles.miniSpacer} />

          <View style={styles.row}>
            {data.category !== undefined && (
              <Element label={labels.category} data={data.category} />
            )}

            {data.type !== undefined && <Element label={labels.type} data={data.type} />}

            {data.riscAssessment !== undefined && (
              <Element label={labels.riscAssessment} data={data.riscAssessment} />
            )}

            {certificationNumbersText !== undefined && (
              <Element
                label={labels.certificationNumbers}
                data={certificationNumbersText}
              />
            )}

            {data.category === undefined && <View style={styles.column} />}
            {data.type === undefined && <View style={styles.column} />}
            {data.riscAssessment === undefined && <View style={styles.column} />}
            {certificationNumbersText === undefined && <View style={styles.column} />}
          </View>
        </>
      )}
    </>
  );
};

export default Biomass;
